import intl from 'react-intl-universal';
import { useState, useEffect } from 'react';
import { Tooltip, Empty } from 'antd';
import { getFileType } from '@/utils/common';
import { default as Modal } from '@/components/CssModal';

interface previewVideo {
    src?: string;
    title?: string;
    removeUrl: (value: any) => void;
}

const Annex = ({ src, title, removeUrl }: previewVideo) => {
    const [type, setType] = useState<string>('');
    const [modalTitle, setModalTtile] = useState('');
    const [visbile, setVisbile] = useState<boolean>(false);

    useEffect(() => {
        if (src) {
            const fileType = getFileType(src);
            if (fileType === 'image') {
                setModalTtile(intl.get('图片'));
            } else if (fileType === 'video') {
                setModalTtile(intl.get('视频'));
            } else if (fileType === 'radio') {
                setModalTtile(intl.get('音频'));
            } else {
                setModalTtile(intl.get('其他'));
            }
            setType(fileType);
            setVisbile(true);
        } else {
            setVisbile(false);
        }
    }, [src]);

    return (
        <Modal
            open={visbile}
            centered
            width={700}
            title={
                <Tooltip title={title || modalTitle}>
                    {title || modalTitle}
                </Tooltip>
            }
            footer={null}
            onCancel={() => {
                removeUrl('');
            }}
        >
            {type === 'image' ? (
                <img
                    alt="example"
                    style={{ width: '100%' }}
                    src={src}
                />
            ) : type === 'video' ? (
                <video
                    style={{
                        maxWidth: '100%',
                        maxHeight: '500px',
                        objectFit: 'cover',
                    }}
                    controls
                    src={src}
                ></video>
            ) : type === 'radio' ? (
                <audio
                    controls
                    style={{ width: '100%' }}
                    src={src}
                ></audio>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </Modal>
    );
};

export default Annex;
